<template>
  <div class="wrapper">
		<div v-if="loading" class="text-center">
			<b-spinner label="Loading..." style="width: 4rem; height: 4rem;" variant="info"></b-spinner>
		</div>
    <div v-else class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card header-tag="header">
            <div slot="header"><i class="fa fa-dollar"></i> Add Payment</div>
            <b-form @submit.prevent="checkFormValidity()" method="post">
              <b-form-group
                label="Select Invoice"
                label-for="unpaidInvoiceList"
								label-class="required"
                :label-cols="3"
                :horizontal="true"
								invalid-feedback="Please select one."
								:state="$v.form.invoiceId.$dirty ? !$v.form.invoiceId.$error : null">
<!--                <b-form-select v-model="form.invoiceId"-->
<!--                               name="invoiceId"-->
<!--                               id="unpaidInvoiceList"-->
<!--                               :plain="true"-->
<!--                               :options="unpaidInvoiceList"-->
<!--                               value="Please select"-->
<!--                               :state="$v.form.invoiceId.$dirty ? !$v.form.invoiceId.$error : null"-->
<!--                               aria-describedby="invoiceId-live-feedback">-->
<!--                </b-form-select>-->
<!--                <b-form-invalid-feedback id="invoiceId-live-feedback">Please select one.</b-form-invalid-feedback>-->
								<model-select id="unpaidInvoiceList" :options="unpaidInvoiceList" v-model="form.invoiceId" :isError="$v.form.invoiceId.$dirty ? $v.form.invoiceId.$error : false" placeholder="Please Select"></model-select>
              </b-form-group>
              <b-form-group
                label="Amount"
                label-for="amount"
								label-class="required"
                :label-cols="3"
                :horizontal="true">
                <b-form-input v-model="form.amount" name="amount" id="amount" type="number" placeholder="Amount" min="1" :state="$v.form.amount.$dirty ? !$v.form.amount.$error : null" aria-describedby="amount-live-feedback"></b-form-input>
                <b-form-invalid-feedback id="amount-live-feedback">This is a required field and must not be 0.</b-form-invalid-feedback>
              </b-form-group>
							<b-form-group
								label="Discount"
								label-for="discount"
								:label-cols="3"
								:horizontal="true">
								<b-form-input v-model="form.discount" name="discount" id="discount" type="number" placeholder="Discount"></b-form-input>
							</b-form-group>
              <b-form-group
                label="Payment Date" label-for="paymentDate"
								label-class="required"
                :label-cols="3"
                :horizontal="true">
                <b-form-input v-model="form.paymentDate" name="paymentDate" type="date" id="paymentDate" :state="$v.form.paymentDate.$dirty ? !$v.form.paymentDate.$error : null" aria-describedby="paymentDate-live-feedback"></b-form-input>
                <b-form-invalid-feedback id="paymentDate-live-feedback">This is a required field.</b-form-invalid-feedback>
              </b-form-group>
              <b-form-group
                label="Remarks"
                label-for="remarks"
                :label-cols="3"
                :horizontal="true">
                <b-form-input v-model="form.remarks" id="remarks" :textarea="true" :rows="9" placeholder="Content.." :state="$v.form.remarks.$dirty ? !$v.form.remarks.$error : null" aria-describedby="remarks-live-feedback"></b-form-input>
								<b-form-invalid-feedback id="remarks-live-feedback">Remarks can not be more than 100 characters.</b-form-invalid-feedback>
              </b-form-group>
              <div class="form-actions">
                <b-button type="submit" variant="primary"><i class="fa fa-dot-circle-o"></i> New Payment Received</b-button>
              </div>
            </b-form>
          </b-card>
        </b-col>
      </b-row>

			<b-row>
				<b-col cols="12">
					<b-card header-tag="header">
						<div slot="header"><i class="icon-eye"></i> View payments</div>
						<b-form-group
							label="Select Invoice"
							label-for="approvedInvoiceList"
							:label-cols="3"
							:horizontal="true">
							<model-select id="approvedInvoiceList" :options="approvedInvoiceList" v-model="invoiceId" placeholder="Please Select"></model-select>
						</b-form-group>
					</b-card>
				</b-col>
			</b-row>

			<b-row>
				<b-col cols="12" v-if="invoiceId != null">
					<b-card header-tag="header">
						<div class="animated fadeIn">
							<genericTable :table-data="invoicewiseTableData" :fields="fields" :per-page=10 hover striped bordered small
														:busy="loadingInvoiceWiseHistoryTable"
														:caption="'<i class=\'icon-list\'></i> Payments for Invoice# ' + invoiceId">
								<template v-slot:row-actions="row">
									<b-button size="sm" variant="info" class="mr-1" @click="downloadInvoice(row.row.item.id)">
										<i class="fa fa-download"></i> Download
									</b-button>
								</template>
							</genericTable>
						</div>
					</b-card>
				</b-col>
			</b-row>

      <b-row>
        <b-col cols="12">
					<div class="animated fadeIn">
						<genericTable :table-data="tableData" :fields="fields" :filter="true" :per-page=50 hover striped bordered small
													caption="<i class='icon-list'></i> Payment History">
							<template v-slot:row-actions="row">
								<b-button size="sm" variant="info" class="mr-1" @click="downloadInvoice(row.row.item.id)">
									<i class="fa fa-download"></i> Download
								</b-button>
							</template>
						</genericTable>
					</div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { required, numeric, minValue, maxLength } from 'vuelidate/lib/validators';
import paymentService from '@/services/paymentService';
import invoiceService from '@/services/invoiceService';
import genericTable from '@/components/GenericTable';
import toastService from "@/services/toastService";
import {ModelSelect} from "vue-search-select";

export default {
  name: 'payment',
	components: {
		"genericTable": genericTable,
		ModelSelect
	},
  data: function () {
    return {
      form: {
        invoiceId: null,
        amount: null,
				discount: null,
        paymentDate: null,
        remarks: null,
      },
      unpaidInvoiceList: [],
			approvedInvoiceList: [],
			invoiceId: null,
			paymentHistoryList: [],
			invoicewisePaymentHistoryList: [],
			fields: [
				{key: 'invoice_id', label: 'Invoice ID', sortable: true},
				{key: 'project_name', label: 'Project Name', sortable: true},
				{key: 'bill_generation_date', label: 'Bill Generation Date', sortable: true},
				{key: 'payment_date', label: 'Payment Date', sortable: true},
				{key: 'total_amount', label: 'Total Amount', sortable: false},
				{key: 'paid_amount', label: 'Paid Amount', sortable: false},
				{key: 'discount', label: 'Discount', sortable: false},
				{key: 'current_due', label : 'Current Due', sortable : false},
				{key: 'remarks', label: 'Remarks', sortable: true},
				{key: 'actions', label: 'Actions', class : 'text-center'}
			],
			loading : false,
			loadingInvoiceWiseHistoryTable : false
    }
  },

  validations: {
    form: {
      invoiceId: {
        required,
        minValue: minValue(1)
      },
      amount: {
        required,
        numeric,
        minValue: minValue(1)
      },
      paymentDate: {
        required
      },
			remarks: {
      	maxLength: maxLength(100)
			}
    }
  },

	created(){
  	this.loading = true;
  	this.getUnpaidInvoiceList();
  	this.getApprovedInvoiceList();
  	this.getPaymentHistories();
	},

  methods: {
    checkFormValidity: function(){
      let formHasErrors = false;

      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        formHasErrors = true;
      }

      if(formHasErrors) return;
      else this.addNewPayment();
    },

    addNewPayment: function () {
      let paymentDateInMillis = new moment(this.form.paymentDate,'YYYY-MM-DD');
      const formData = {
				invoiceId: this.form.invoiceId,
				paidAmount: this.form.amount,
				discountedAmount: this.form.discount,
				paymentDate: paymentDateInMillis.format('x'),
				remarks: this.form.remarks,
				paymentReceiverId: 0
			};

			paymentService.addPaymentForAnInvoice(formData, (data) => {
				this.paymentHistoryList = this.createPaymentHistoryListTable(data);
				this.resetForm();
				this.$nextTick(() => { this.$v.$reset() });
				this.getUnpaidInvoiceList();
				toastService.showSuccessToast("Payment added successfully.")
			}, (error) => {
				toastService.showErrorToast("Could not store payment history " + error);
			});

			return false;
    },

		getUnpaidInvoiceList: function () {
			invoiceService.getUnpaidInvoiceList((data) => {
				this.unpaidInvoiceList = this.createInvoiceDropDownList(data);
			}, (error) => {
				toastService.showErrorToast("Could not fetch invoice list" + error);
			})
		},

		getApprovedInvoiceList: function () {
			invoiceService.getApprovedInvoiceList((data) => {
				this.approvedInvoiceList = this.createInvoiceDropDownList(data);
			}, (error) => {
				toastService.showErrorToast("Could not fetch invoice list" + error);
			})
		},

		getPaymentHistories: function(){
			// eslint-disable-next-line no-mixed-spaces-and-tabs
    	paymentService.getPaymentHistoryList((data) => {
				this.paymentHistoryList = this.createPaymentHistoryListTable(data);
				this.loading = false;
			}, (error) => {
				toastService.showErrorToast("Could not fetch payment histories" + error);
				this.loading = false;
			});
		},

		getInvoicewisePaymentHistories: function(){
			if(!this.invoiceId) return;
			this.loadingInvoiceWiseHistoryTable = true;
			paymentService.getPaymentHistoryListOfAnInvoice(this.invoiceId, (data) => {
				this.invoicewisePaymentHistoryList = this.createPaymentHistoryListTable(data);
				this.loadingInvoiceWiseHistoryTable = false;
			}, (error) => {
				toastService.showErrorToast("Could not fetch payment histories" + error);
				this.loadingInvoiceWiseHistoryTable = false;
			});
		},

		createPaymentHistoryListTable: function(data){
    	let historyList = [];
			data.forEach((value, index) => {
				let row = new Object();
				row.id = value.id;
				row.invoice_id = value.invoiceId;
				row.project_name = value.subscriberProjectName;
				row.bill_generation_date = moment(value.billGenerationDate).format('DD-MM-YYYY');
				row.payment_date = moment(value.paymentDate).format('DD-MM-YYYY');
				row.total_amount = value.totalAmount ? value.totalAmount.toFixed(2) : "N/A";
				row.paid_amount = value.paidAmount ? value.paidAmount.toFixed(2) : "N/A";
				row.discount = value.discountedAmount ? value.discountedAmount.toFixed(2) : "N/A";
				row.current_due = value.currentDue !== null ? value.currentDue.toFixed(2) : "N/A";
				row.remarks = value.remarks;
				historyList.push(row);
			});

			return historyList;
		},

		createInvoiceDropDownList: function (data) {
    	let invoiceList = [ {text: 'Please select', value: null} ];
			data.forEach((value, index) => {
				let invoice = new Object();
				invoice.text = "Invoice# " + value.id + ", Project Name: " + value.subscription.subscriberProjectName;
				invoice.value = value.id;
				invoiceList.push(invoice);
			});

			return invoiceList;
		},

		resetForm: function () {
			this.form.invoiceId = null;
			this.form.amount = null;
			this.form.discount = null;
			this.form.paymentDate = null;
			this.form.remarks = null;
			// this.$v.reset();
		},

		downloadInvoice : function (paymentHistoryId) {
			paymentService.downloadInvoice(paymentHistoryId, (data) => {

			}, (error) => {
				toastService.showErrorToast("Could not download invoice");
			});
		}

  },

	computed: {
		tableData : function(){
			return this.paymentHistoryList;
		},

		invoicewiseTableData : function () {
			return this.invoicewisePaymentHistoryList;
		}
	},

	watch: {
		invoiceId : function (newVal) {
			if(newVal !== null) this.getInvoicewisePaymentHistories();
		}
	}
}
</script>

<style src="vue-search-select/dist/VueSearchSelect.css"></style>
